import {OrderConstants, SET_ORDER} from "../../../constants/EventsConstants";
import {GeneralAction} from "../../../@types/actions";

export const SetOrderAction = (data: OrderConstants): GeneralAction<OrderConstants> => ({
    type: SET_ORDER,
    payload: data
});
